import { Controller } from '@hotwired/stimulus';
import { application } from 'src';

application.register('cookie-management', class extends Controller {
  agreeToAll () {
    event.preventDefault();
    this.setCookie('yes');
    window.location.reload();
  }

  agreeEssential () {
    event.preventDefault();
    this.setCookie('no');
    window.location.reload();
  }

  setCookie (answer) {
    Cookies.set('allow_cookies', answer, { expires: 365 });
  }
});
